export default __webpack_public_path__ + "0b326d5cfd5d9622edb6b1e7c5b6f8d2.webp";